import React, { Fragment } from 'react';
import { useMediaQuery } from 'react-responsive';
import { FaCheck } from 'react-icons/fa';
import clsx from 'clsx';
import { MrJ2, MJTitleBelow, JournalerAi } from '../../assets/mrJournaler/imageMJ.jsx';
import styles from './mrJournaler.module.css';
import AIInfoSection from '../home/components/AIInformation/index.jsx';

const MrJournaler = () => {
  const isMobile = useMediaQuery({ maxWidth: 700 });

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const features = [
    {
      title: 'Instant AI-Powered Support',
      listItem: [
        'Navigate features and workflows with natural-language chat',
        'Receive guided support for imports, exports, and reconciliations',
        'Automate transaction categorisation'
      ]
    },
    {
      title: 'Real-Time Crypto Accounting News Updates',
      listItem: [
        'Search crypto-accounting knowledge and get real-time insights',
        'Stay updated on tax rules, compliance, and best practices'
      ]
    }
  ]

  return (
    <div className={styles.MJcontainer}>
      {/* Hero Section */}
      <div className={styles.whoMJ}>
        <img src={MrJ2} alt='Mr.Journaler' className={styles.gifImg} />
      </div>

      {/* Title Section */}
      <div className={clsx(styles.MJTitleSection, !isMobile && 'container')}>
        <div className={styles.MJTitleLogo}>
          <img src={MJTitleBelow} alt='MR.JOURNALER' className={styles.MJTitleBelow} />
        </div>
        <h1 className={styles.MJTitleText}>Your AI-Powered Crypto Accounting Assistant</h1>
        <h2 className={styles.MJComingSoon}>Coming Soon</h2>
        <p className={styles.MJByAEM}>by AEM Algorithm</p>
      </div>
      {/* Features Section */}
      <div className={styles.MJFeaturesSectionContainer}>
        <div className={clsx(styles.MJFeaturesSection, !isMobile && 'container')}>
          <div className={styles.MJFeaturesContent}>
            {isMobile ? (
              <>
                <div className={styles.MJFeaturesIllustration}>
                  <img src={JournalerAi} alt="Mr. Journaler AI" className={styles.MJIllustrationImg} />
                </div>
                <div className={styles.MJFeaturesContentSection}>
                  <h2 className={styles.MJFeaturesTitle}>Meet the next evolution of Mr. Journaler</h2>
                  <p className={styles.MJFeaturesSubtitle}>
                    An AI engine that makes crypto accounting faster, smarter, and fully automated.
                  </p>
                  <div className={styles.MJFeaturesListContent}>
                    {features.map((feature, index) => (
                      <Fragment key={index}>
                        <span className={styles.MJListTitle}>{feature.title}</span>
                        {feature.listItem.map((item, index) => (
                          <div key={index} className={styles.MJFeatureItem}>
                            <FaCheck className={styles.MJCheckIcon} />
                            <p className={styles.MJFeatureText}>{item}</p>
                          </div>
                        ))}
                      </Fragment>
                    ))}
                  </div>
                  <button
                    className={styles.MJSignUpButton}
                    onClick={() => window.open('https://journaler.aem.ac/user/register', '_blank')}
                  >
                    Sign up to Journaler software
                  </button>
                </div>
              </>
            ) : (
              <>
                <div className={styles.MJFeaturesHeader}>
                  <h2 className={styles.MJFeaturesTitle}>Meet the next evolution of Mr. Journaler</h2>
                  <p className={styles.MJFeaturesSubtitle}>
                    An AI engine that makes crypto accounting faster, smarter, and fully automated.
                  </p>
                </div>
                <div className={styles.MJFeaturesListContainer}>
                  <div className={styles.MJFeaturesList}>
                    <div className={styles.MJFeaturesListContent}>
                      {features.map((feature, index) => (
                        <Fragment key={index}>
                          <span className={styles.MJListTitle}>{feature.title}</span>
                          {feature.listItem.map((item, index) => (
                            <div key={index} className={styles.MJFeatureItem}>
                              <FaCheck className={styles.MJCheckIcon} />
                              <p className={styles.MJFeatureText}>{item}</p>
                            </div>
                          ))}
                        </Fragment>
                      ))}
                    </div>
                    <div className={styles.MJFeaturesIllustration}>
                      <img src={JournalerAi} alt="Mr. Journaler AI" className={styles.MJIllustrationImg} />
                    </div>
                  </div>
                  <button
                    className={styles.MJSignUpButton}
                    onClick={() => window.open('https://journaler.aem.ac/user/register', '_blank')}
                  >
                    Sign up to Journaler software
                  </button>
                </div>

              </>
            )}

          </div>
        </div>
        <AIInfoSection headerTitle={<> AI solutions for <br /> crypto accounting</>} isHiddenLogo />
      </div>
    </div>
  )
}

export default MrJournaler
